module.exports = __webpack_public_path__ + "static/media/save.16eb863a.svg";